exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ToggleSwitch_Row_1Jmlz {\n    display: flex;\n    flex-flow: row;\n    margin-top: 15px;\n    /*padding-left: 10px;*/\n    /*border: 1px solid black;*/\n    width: 100%;\n}\n\n.ToggleSwitch_Label_3jSId {\n    width: 60%;\n    font-weight: bolder;\n    /*padding-top: 15px;*/\n    /*border: 1px solid blue;*/\n}\n\n.ToggleSwitch_ToggleButton_sGTZH {\n    width: 40%;\n    text-align: right;\n    /*padding-top: 15px;*/\n    /*border: 1px solid green;*/\n}\n\n.ToggleSwitch_On_I5z3r {\n    color: green;\n    font-style: italic;\n}\n\n.ToggleSwitch_Off_3w8xq {\n    color: red;\n    font-style: italic;\n}", ""]);

// Exports
exports.locals = {
	"Row": "ToggleSwitch_Row_1Jmlz",
	"Label": "ToggleSwitch_Label_3jSId",
	"ToggleButton": "ToggleSwitch_ToggleButton_sGTZH",
	"On": "ToggleSwitch_On_I5z3r",
	"Off": "ToggleSwitch_Off_3w8xq"
};